module.exports = __webpack_public_path__ + "0ed76dff8b27fe96ead4a4fbfb85fde9.pdf";